module.exports = __webpack_public_path__ + "static/media/support_female_hjszor.63443998.jpg";